<template>
  <div id="contenedor-auditoria-contratos-nuevo">
    <v-form
      v-model="formularioValido"
      ref="agregarAuditoriaContratos">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nuevo Contrato
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
            <contratos-picker
            v-on:input="inputContrato"
            :idContrato="contrato.idContrato"
            :multiSelect="false"
            cols="12">
            </contratos-picker>
            <v-row>
              <v-col cols="6">
                <custom-text-field
                v-model="contrato.ultimaEstimacionAuditada"
                label="Última Estimación Auditada"
                >
                </custom-text-field>
              </v-col>
              <v-col cols="6">
                <custom-text-field
                v-model.number="contrato.porcentajeAvanceAuditado"
                label="Porcentaje Avance Auditado"
                type="number"
                suffix="%"
                >
            </custom-text-field>
              </v-col>
            </v-row>

        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarAuditoriaContrato"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixContratos from './mixContratos';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import ContratosPicker from '@/components/ContratosPicker.vue';

export default {
  name: 'AuditoriaContratosNuevo',
  props: {
    idAuditoria: {
      type: String,
      required: true,
    },
  },
  mixins: [mixContratos],
  components: {
    CustomTextField,
    CustomButton,
    ContratosPicker,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      contrato: {
        // idContrato: 'b0d59a92-5b45-444b-b50c-c0f26b29b699',
        idContrato: null,
        idAuditoria: this.idAuditoria,
        ultimaEstimacionAuditada: null,
        porcentajeAvanceAuditado: null,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.agregarAuditoriaContratos.reset();
    },
    inputContrato(contratoSeleccionado) {
      this.contrato.idContrato = contratoSeleccionado.id;
    },
  },
};
</script>

<style>
</style>
